import LabServiceCollection from "@/collections/LabServiceCollection";
import AnalyteRangeModel from "@/models/lab/AnalyteRangeModel";

export default class AnalyteRangeCollection extends LabServiceCollection {

  model() {
    return AnalyteRangeModel;
  }

}
